import { t } from '../../utils/helpers';
import { Checkbox } from '@ui-kit/components/checkbox';
import classnames from 'classnames';

export default function TermsAndConditions(props: {
  status: boolean,
  handleStatus: () => void,
  classWrap?: string,
  id: string,
}) {
  return (
    <div className={classnames(props.classWrap, 'rules')}>
      <Checkbox
        id={props.id}
        checked={props.status}
        name="terms-and-conditions"
        handler={props.handleStatus}
        className="rules__input-ticket-wrap"
        classInput="rules__ticket-input"
        classLabel="rules__label"
      >
        {t('i_read_and_agree_to_the')}
      </Checkbox>
      <a
        className="rules__link"
        target="_blank"
        rel="noreferrer"
        href="https://gameclubusa.com/wp/terms.html"
      >
        {t('terms_and_conditions')}
      </a>
    </div>
  );
};
